// import
import React, { Component } from 'react'
import { BrowserRouter, Route, Switch, Redirect } from 'react-router-dom'
import AuthLayout from 'layouts/Auth.js'
import AdminLayout from 'layouts/Admin.js'
import Dashboard from 'views/Dashboard/Dashboard.js'
import Tables from 'views/Dashboard/Tables.js'
import SignIn from 'views/Pages/SignIn.js'
import Courses from 'views/Course/List.js'
import CourseDetail from 'views/Course/Detail'
import DocumentList from 'views/Document/List'
import EmployeeList from 'views/Employee/List'
import UpdateOrCreateDocument from 'views/Document/UpdateOrCreate'
import HandleLogin from 'views/Pages/HandleLogin'
import JobAssignHistoryList from 'views/JobAssignHistory/List'
import IndividualTrainingAssign from 'views/IndividualTraining/IndividualTrainingAssign'

import {
  HomeIcon,
  StatsIcon,
  CreditIcon,
  PersonIcon,
  DocumentIcon,
  RocketIcon,
  SupportIcon
} from 'components/Icons/Icons'
import { STORAGE } from 'constants/common'
import { getCookie } from 'utils'
import CourseForm from 'views/Course/CourseForm'
import NotFound from 'views/NotFound'
import CourseDetailIndividual from 'views/Course/DetailIndividual'
import { Image } from '@chakra-ui/react'

import iconTrainingAll from 'assets/img/icon-training-all.png';
import iconIndividual from 'assets/img/icon-individual-training.png';
import iconCourseManagement from 'assets/img/icon-course-management.png';
import iconAdminSetting from 'assets/img/admin-setting.png';
import iconExport from 'assets/svg/export-icon.svg';
import IndividualTrainingAssignEmployee from 'views/IndividualTraining/IndividualTrainingAssignEmployee'
import IndividualTrainings from 'views/IndividualTraining/List'
import IndividualCourseForm from 'views/Course/IndividualCourseForm'
import ExportExcelEmployee from 'views/Export/ExportExcelEmployee';

const accessToken = getCookie(STORAGE.ACCESS_TOKEN)

export const dashRoutes = [
  {
    path: '/login',
    name: 'Login',
    icon: <StatsIcon color='inherit' />,
    component: SignIn,
    layout: '/auth'
  },
  {
    path: '/handle/login',
    name: '',
    icon: <DocumentIcon color='inherit' />,
    component: HandleLogin,
    layout: '/auth',
    hideMenu: true
  },
  {
    path: '/not-found',
    name: '',
    icon: <DocumentIcon color='inherit' />,
    component: NotFound,
    layout: '/admin',
    hideMenu: true
  },

  //COURSES
  {
    path: '/courses',
    name: 'pages.courses.title',
    sideBar: 'pages.courses.title',
    icon: <Image boxSize="32px" src={iconTrainingAll} alt="Training all" />,
    component: Courses,
    layout: '/admin',
    /*breadCrumb: [{ label: 'pages.courses.title', link: '/admin/courses' }]*/
  },
  {
    path: '/courses/detail/:courseId',
    name: 'pages.courses.detail.title',
    component: CourseDetail,
    layout: '/admin',
    hideMenu: true,
    /*breadCrumb: [
      { label: 'pages.courses.title', link: '/admin/courses' },
      { label: 'pages.courses.detail.title', link: null }
    ]*/
  },
  {
    path: '/courses/create',
    name: '',
    icon: <StatsIcon color='inherit' />,
    component: CourseForm,
    layout: '/admin',
    hideMenu: true,
    /*breadCrumb: [
      { label: 'pages.courses.title', link: '/admin/courses' },
      { label: 'pages.course_form.title_create', link: '/admin/courses/create' }
    ]*/
  },
  {
    path: '/courses/edit/:courseId',
    name: '',
    icon: <StatsIcon color='inherit' />,
    component: CourseForm,
    layout: '/admin',
    hideMenu: true,
    /*breadCrumb: [
      { label: 'pages.courses.title', link: '/admin/courses' },
      { label: 'pages.course_form.title_edit', link: null }
    ]*/
  },

  //individual training assign random
  {
    path: '/individual-training',
    name: 'pages.individual.individual_training',
    sideBar: 'pages.individual.individual_training',
    hideMenu: false,
    icon: <Image boxSize="32px" src={iconIndividual} alt="Dan Abramov" />,
    component: IndividualTrainingAssign,
    layout: '/admin',
  },

  //individual training list
  {
    path: '/individual-training/list',
    name: '',
    hideMenu: true,
    icon: <Image boxSize="32px" src={iconIndividual} alt="" />,
    component: IndividualTrainings,
    layout: '/admin',
  },

  {
    path: '/individual-training/courses/create',
    name: '',
    icon: <StatsIcon color='inherit' />,
    component: IndividualCourseForm,
    layout: '/admin',
    hideMenu: true,
  },

  {
    path: '/individual-training/courses/detail/:courseId',
    name: 'pages.courses.detail.title',
    component: CourseDetailIndividual,
    layout: '/admin',
    hideMenu: true,
  },

  {
    path: '/individual-training/courses/edit/:courseId',
    name: '',
    icon: <StatsIcon color='inherit' />,
    component: IndividualCourseForm,
    layout: '/admin',
    hideMenu: true,
  },

  //individual training assign employees
  {
    path: '/individual-training/assign-training',
    name: '',
    hideMenu: true,
    icon: <Image boxSize="32px" src={iconIndividual} alt="" />,
    component: IndividualTrainingAssignEmployee,
    layout: '/admin',
  },
  
    //EXPORT EXCEL EMPLOYEE
    {
      path: '/export-csv',
      name: 'pages.export.title',
      sideBar: 'pages.export.title',
      icon:<Image boxSize="32px" src={iconExport} alt="Export excel" opacity={0.7}/>,
      component: ExportExcelEmployee,
      layout: '/admin',
    },
  

  //DOCUMENTS
  {
    path: '/documents',
    name: 'pages.document.list.title',
    sideBar: 'pages.document.list.sidebar',
    icon: <Image boxSize="32px" src={iconCourseManagement} alt="Course Management" />,
    component: DocumentList,
    layout: '/admin',
    /*breadCrumb: [
      { label: 'pages.document.list.title', link: '/admin/documents' }
    ]*/
  },
  {
    path: '/documents/create',
    name: 'pages.document.title_create',
    icon: <StatsIcon color='inherit' />,
    component: UpdateOrCreateDocument,
    layout: '/admin',
    hideMenu: true,
    /*breadCrumb: [
      { label: 'pages.document.list.title', link: '/admin/documents' },
      { label: 'pages.document.title_create', link: null }
    ]*/
  },
  {
    path: '/documents/edit/:id',
    name: 'pages.document.title_edit',
    icon: <StatsIcon color='inherit' />,
    component: UpdateOrCreateDocument,
    layout: '/admin',
    hideMenu: true,
    /*breadCrumb: [
      { label: 'pages.document.list.title', link: '/admin/documents' },
      { label: 'pages.document.title_edit', link: null }
    ]*/
  },

  {
    path: '/employees',
    name: 'pages.employee.title',
    sideBar: 'pages.employee.title',
    icon: <Image boxSize="32px" src={iconAdminSetting} alt="Admin setting" />,
    component: EmployeeList,
    layout: '/admin',
    /*breadCrumb: [
      { label: 'pages.employee.title', link: '/admin/employees' },
    ]*/
  },

  //JOB ASSIGN HISTORY
  {
    path: '/job-history/:id',
    name: 'pages.job_assign_history.list.title',
    hideMenu: true,
    icon: <DocumentIcon color='inherit' />,
    component: JobAssignHistoryList,
    layout: '/admin',
  },
]

const Router = () => {
  return (
    <BrowserRouter>
      <Switch>
        <Route path={`/auth`} component={AuthLayout} />
        <Route path={`/admin`} component={AdminLayout} />
        <Redirect from='/' to='/admin' />
      </Switch>
    </BrowserRouter>
  )
}
export default Router
